import { render, staticRenderFns } from "./KitNoAccess.vue?vue&type=template&id=687aed82&scoped=true&"
import script from "./KitNoAccess.vue?vue&type=script&lang=ts&"
export * from "./KitNoAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687aed82",
  null
  
)

export default component.exports